module.exports = __webpack_public_path__ + "img/icon1.696c2af2.png";